import React, { type JSX, Suspense, lazy } from 'react'
import ModalPageHeader from '@mobi/account/Common/ModalPageHeader'
import { useBetAccount } from '@mobi/account/Hooks'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { useDisableAppHeaderRender } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderRender'
import { useDisableTabNavigationRender } from '@core/Areas/Navigation/Hooks/useDisableTabNavigationRender'
import { MainContainer } from '@core/Components/Containers'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'
import { fullClientVersion } from '@core/Utils/clientVersion'

const App = lazy(() => import('@mobi/account/Areas/Reverification/Components/App'))

export const Reverification = (): JSX.Element | null => {
  useDisableAppHeaderRender()
  useDisableTabNavigationRender()
  const { accountNumber } = useAuthenticatedAccount()
  const { data: betAccount } = useBetAccount({
    enabled: accountNumber !== null,
  })

  return (
    <Suspense fallback={<Spinner />}>
      <ModalPageHeader
        onClickNeedHelp={() => {
          // TODO: Add analytics
        }}
        onClickHome={() => {
          // TODO: Add analytics
        }}
      />
      <MainContainer background='white'>
        <App
          betAccountNumber={accountNumber}
          appVersion={fullClientVersion}
          reverificationDueDate={betAccount?.ReverificationDueDate ?? ''}
        />
      </MainContainer>
    </Suspense>
  )
}
